import { defineStore } from 'pinia';

export enum LandingPages {
  ALL_FILES = 'allFiles',
  FAVORITES = 'favorites',
  COLLECTIONS = 'collections',
  HISTORY = 'history',
  TRASH = 'trash',
  REQUEST_VIDEO = 'requestVideo',
}

export interface LandingItem {
  title: string;
  description: string;
  video: string;
  learMoreLink: string;
  learnMoreText: string;
}

export interface LandingState {
  list: { [K in LandingPages]: LandingItem };
}

export const useLandingStore = defineStore('landingStore', {
  state: () =>
    ({
      list: {
        allFiles: {
          title: 'Get Your Content Here',
          description: 'A one-stop-shop for all the content you upload or create with Zight available here.',
          video: 'https://share.zight.com/04uyKPdL?embed=true',
          learMoreLink: 'https://www.zight.com/features/',
          learnMoreText: 'Learn more about features',
        },
        history: {
          title: 'Engagement Timeline',
          description: 'Take a look back at your recently shared content links to see if they were viewed by who and when.',
          video: 'https://share.zight.com/Z4um5L27?embed=true',
          learMoreLink: 'https://support.getcloudapp.com/hc/en-us/articles/6657187070231-How-can-I-see-my-recent-activity-and-my-team-s-activity-',
          learnMoreText: 'Learn more about history',
        },
        favorites: {
          title: 'Most loved',
          description: 'Give frequently used screenshots or recordings a gold star for easy access in your favorites',
          video: 'https://share.zight.com/kpuOYLee?embed=true',
          learMoreLink: 'https://support.getcloudapp.com/hc/en-us/articles/5842317785239-How-do-I-add-a-drop-to-my-favorites-',
          learnMoreText: 'Learn more about favorites',
        },
        collections: {
          title: 'Group It Up',
          description:
            'Organize your content into collections for easy access and consumption of multiple screenshots and recordings. Great for onboarding and tutorials!',
          video: 'https://share.zight.com/7KujR0nm?embed=true',
          learMoreLink: 'https://www.getcloudapp.com/collections/',
          learnMoreText: 'Learn more about collections',
        },
        trash: {
          title: 'Keep it tidy',
          description: 'Don’t be afraid to clean up your content. We’ll keep it around for 30 days in case you change your mind.',
          video: 'https://share.zight.com/OAu2rbN1?embed=true',
          learMoreLink: 'https://support.getcloudapp.com/hc/en-us/articles/5842280510359-How-do-I-recover-a-deleted-content-',
          learnMoreText: 'Learn more about trash',
        },
        requestVideo: {
          title: 'Request Video',
          description: 'Easily Request and Collect Videos — No Downloads Needed',
          video: 'https://share.zight.com/4guLvene?embed=true',
          learMoreLink: 'https://zight.com/request-video/',
          learnMoreText: 'Request access',
        },
      },
    }) as LandingState,
  getters: {
    getByType: (state: LandingState) => (type: LandingPages) => state.list[type],
  },
});
